import { useState } from 'react';
import { faMoneyCheckDollarPen } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tooltip from 'rc-tooltip';
import { ROLE_TYPES } from '@/Interfaces/Data';
import { useAppSelector } from '@/_store/hooks';
import { ModalConfirmResetBalance } from './components/modal-confirm-reset-balance';
import styles from './styles.module.scss';
import { selectUser } from '@/_store/modules/auth/selectors';

function ResetBalance() {
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const user = useAppSelector(selectUser);

  return user?.managerLogType === ROLE_TYPES.ADMIN ? (
    <>
      <Tooltip overlay="Zerar saldo" placement="top">
        <button
          type="button"
          onClick={() => setOpenModalConfirm(true)}
          className={styles.buttonStyle}
        >
          <FontAwesomeIcon icon={faMoneyCheckDollarPen} size="lg" />
        </button>
      </Tooltip>

      <ModalConfirmResetBalance
        open={openModalConfirm}
        onClose={() => setOpenModalConfirm(false)}
      />
    </>
  ) : null;
}

export { ResetBalance };
